import axios from "axios";

export const adminFetchUsersApi = async (
  token,
  signal,
  pageNr = null,
  sortKey = false,
  filterKey = false
) => {
  // fetches all users
  // token (String): bearer token used for authentication
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  // pageNr (Number): the new page nr requested by the user (pagination)
  // sortKey (String): the attribute to sort on, eg "date_1"
  // filterKey (String): the attribute to filter on, eg "isAdmin_1"
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    let queryParams = "";
    if (pageNr) {
      queryParams = `?pageNr=${pageNr}`;
    }
    if (sortKey) {
      queryParams = queryParams ? queryParams + "&" : "?";
      queryParams += `sortKey=${sortKey}`;
    }
    if (filterKey) {
      queryParams = queryParams ? queryParams + "&" : "?";
      queryParams += `filterKey=${filterKey}`;
    }
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/users${queryParams}`, config, {
      signal,
    });
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const adminFetchUserApi = async (token, userId, signal) => {
  // fetches the user info for the specified user
  // token (String): bearer token used for authentication
  // userId (String): the id of the user to be fetched
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/admin/${userId}`, config, {
      signal,
    });
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const setAdminStatusApi = async (token, userId, newStatus, signal) => {
  // fetches all users
  // token (String): bearer token used for authentication
  // userId (String): the id of the user to be updated
  // newStatus (JSON): {isAdmin (Boolean)}
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/users/${userId}/set-admin`,
      { isAdmin: newStatus },
      config,
      { signal }
    );
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const fetchUserApi = async (id, token, signal) => {
  // fetches the user with the specified id
  // id (String): the id of the user to be fetched
  // token (String): bearer token used for authentication
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/${id}`, config, { signal });
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const updateUserApi = async (id, updatedUser, token, signal) => {
  // put request to the server to update a specified user
  // id (String): the id of the user to be udpated
  // updatedUser (JSON): object with the udpated user data
  // token (String): bearer token used for authentication
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/users/${id}`, updatedUser, config, {
      signal,
    });
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const adminDeleteUserApi = async (token, userId, signal) => {
  // delete request to the server to delete a specified user
  // token (String): bearer token used for authentication
  // userId (String): the id of the user to be deleted
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.delete(`${process.env.REACT_APP_API_URL}/api/users/admin/${userId}`, config, {
      signal,
    });

    return data;
  } catch (error) {
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};
